module.exports = __webpack_public_path__ + "static/media/1 28 utviklingsmuligheter.4d8ca939.mp3";